import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AccountService } from './../_services';
import { UserData } from '@app/_models';
import { RouteInfo } from '@app/_models/Portal/Menu';
import { RolesUsuario } from '@app/_models/Roles';
import { PortalService } from '@app/_services/Portal/portal.services';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private router: Router, private accountService: AccountService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = this.accountService.userValue;
    const userInfo = this.accountService.userInfo;

    if (user) {
      if (state.url.startsWith('/dashboard') && !this.puedeVerDashboard(userInfo)) {
        this.router.navigate([this.getDefaultRouteByRole(userInfo)]);
        return false;
      }
      return true;
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/publico/login'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }

  private puedeVerDashboard(userInfo: UserData | null): boolean {
    if (!userInfo?.Role) {
      return false;
    }

    return [
      RolesUsuario.MasterRole,
      RolesUsuario.AdministradorRole,
      RolesUsuario.OperadorRole,
      RolesUsuario.AD_Consultor,
      RolesUsuario.CobranzaRole,
      RolesUsuario.ContabilidadRole,
      RolesUsuario.CuentasXPagarRole,
      RolesUsuario.DireccionMedicaRole,
    ].includes(userInfo.Role);
  }

  private getDefaultRouteByRole(userInfo: UserData | null): string {
    if (!userInfo) {
      return '/publico/login';
    }

    if (
      userInfo.Role === RolesUsuario.AgenteRole ||
      userInfo.Role === RolesUsuario.OdemRole ||
      userInfo.Role === RolesUsuario.PromotorRole
    ) {
      return '/solicitudes/solicitudes';
    }

    if (userInfo.Role === RolesUsuario.Asociado) {
      return '/usuarios/perfil';
    }

    if (this.puedeVerDashboard(userInfo)) {
      return '/dashboard';
    }

    return '/publico/login';
  }
}
@Injectable({ providedIn: 'root' })
export class AuthGuardChild  {
  constructor(
    private router: Router,
    private accountService: AccountService,
    private portalService: PortalService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = this.accountService.userValue;
    const userInfo = this.accountService.userInfo;
    if (user) {
      const menuItems = this.getStoredMenuItems();

      if (menuItems.length > 0) {
        return this.hasRoutePermission(menuItems, state.url);
      }

      if (!userInfo?.Role) {
        this.router.navigate(['/publico/Login'], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }

      return this.portalService.getMenuByRole(userInfo.Role).pipe(
        map((result) => {
          localStorage.setItem('menuItems', JSON.stringify(result));
          return this.hasRoutePermission(result, state.url);
        }),
        catchError(() => {
          this.router.navigate(['/publico/Login'], {
            queryParams: { returnUrl: state.url },
          });
          return of(false);
        })
      );
    }
    this.router.navigate(['/publico/Login'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }

  private getStoredMenuItems(): RouteInfo[] {
    const menuItems = localStorage.getItem('menuItems');

    if (!menuItems) {
      return [];
    }

    try {
      return JSON.parse(menuItems) || [];
    } catch {
      return [];
    }
  }

  private hasRoutePermission(menuItems: RouteInfo[], url: string): boolean {
    const currentPath = url.split('?')[0];

    return menuItems.some((item: RouteInfo) => {
      if (item.path && (currentPath === item.path || currentPath.startsWith(item.path + '/'))) {
        return true;
      }

      return item.children?.some((child: any) => {
        if (!child.path) return false;
        return currentPath === child.path || currentPath.startsWith(child.path + '/');
      }) ?? false;
    });
  }
}
const ValidatePermision = (route: Router, path: string): boolean => {
  const menuItems: RouteInfo[] = JSON.parse(localStorage.getItem('menuItems'));

  const hasPermissions = menuItems.some((item: RouteInfo) => {
    console.log(
      '🚀 ~ ValidatePermision ~ item:',
      item?.path,
      '===',
      `/${path}`
    );
    if (item?.path === `/${path}`) {
      return true;
    }
    return false;
  });
  console.log('🚀 ~ hasPermissions ~ hasPermissions:', hasPermissions);
  return hasPermissions;
};
